import React, { useState, useEffect, useRef, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import Cookies from "universal-cookie";
import config from "../../config.js";
import Table from "../Table.js";
import { error } from "../../utils/logger.js";
const GroupTable = ({ setRowEventListener, onGroupSelect }) => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const tableInitialized = useRef(false);

  useEffect(() => {
    const fetchData = async () => {
      const cookies = new Cookies();
      const userToken = cookies.get("userToken");
      const headers = {
        Authorization: `Bearer ${userToken}`,
        "Content-Type": "application/json",
      };
      try {
        setLoading(true);
        const res = await axios.get(`${config.BACKEND_URL}/usergroups`, {
          headers,
        });
        setGroups(
          (res.data.data || []).map((group) => ({
            id: group.id,
            name: group.name,
            userIDs: group.userIDs,
          }))
        );
        setLoading(false);
      } catch (err) {
        error(err);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (
      !loading &&
      groups.length > 0 &&
      setRowEventListener &&
      !tableInitialized.current
    ) {
      const timer = setTimeout(() => {
        setRowEventListener();
        tableInitialized.current = true;
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [groups, setRowEventListener, loading]);

  // Memoize columns to prevent unnecessary table rebuilds
  const columns = React.useMemo(
    () => [
      { title: "id", field: "id", visible: false },
      { title: "Group Name", field: "name", headerFilter: "input" },
    ],
    []
  );

  const handleSelectionChange = useCallback(
    (selectedData) => {
      onGroupSelect(selectedData);
    },
    [onGroupSelect]
  );

  return (
    <div className="GroupTable" style={{ padding: "25px" }}>
      {!loading && groups.length > 0 && (
        <Table
          key="groupTable"
          tableID="groupTable"
          tableData={groups}
          tableColumns={columns}
          displaySerial={true}
          isSelectable={true}
          onSelectionChange={handleSelectionChange}
        />
      )}
    </div>
  );
};

export default React.memo(GroupTable);
